import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const TruckChallanNewPage = lazy(() => import("@/pages/loading-slips.new.page"));

export const Route = createFileRoute("/loading-slips/new")({
  component: TruckChallanNewPage,
  validateSearch: (search: Record<string, unknown>): { biltyId?: string } => ({
    biltyId: typeof search.biltyId === "string" ? search.biltyId : undefined,
  }),
});
